import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  sabbaticalLeaveRequests: [],
  sabbaticalLeaveRequest: {},
  commonReasons: [],
  totalSabbaticalLeaveRequests: [],
  listSabbaticalRequest: [],
  expireSabbatical: [],
  expireSabbaticalDashboard: [],
  expireSabbaticalLog: [],
  expireSabbaticalLeave: 0,
};

// getters
export const getters = {
  sabbaticalLeaveRequests: state => state.sabbaticalLeaveRequests,
  sabbaticalLeaveRequest: state => state.sabbaticalLeaveRequest,
  commonReasons: state => state.commonReasons,
  pagination: state => state.pagination,
  totalSabbaticalLeaveRequests: state => state.totalSabbaticalLeaveRequests,
  listSabbaticalRequest: state => state.listSabbaticalRequest,
  expireSabbatical: state => state.expireSabbatical,
  expireSabbaticalDashboard: state => state.expireSabbaticalDashboard,
  expireSabbaticalLog: state => state.expireSabbaticalLog,
  expireSabbaticalLeave: state => state.expireSabbaticalLeave,
};

// mutations
export const mutations = {
  [types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_REQUEST](
    state,
    sabbaticalLeaveRequests
  ) {
    state.sabbaticalLeaveRequests = sabbaticalLeaveRequests;
    state.pagination.from = sabbaticalLeaveRequests.from;
    state.pagination.to = sabbaticalLeaveRequests.to;
    state.pagination.totalPage = sabbaticalLeaveRequests.last_page;
    state.pagination.path = sabbaticalLeaveRequests.path;
    state.pagination.currentPage = sabbaticalLeaveRequests.current_page;
    state.pagination.totalRecord = sabbaticalLeaveRequests.total;
    state.pagination.perPage = sabbaticalLeaveRequests.per_page;
  },
  [types.SABBATICAL_LEAVE_REQUEST.FETCH_TOTAL_SABBATICAL_LEAVE_REQUEST](state, totalSabbaticalLeaveRequests) {
    state.totalSabbaticalLeaveRequests = totalSabbaticalLeaveRequests;
  },
  [types.SABBATICAL_LEAVE_REQUEST.DETAIL_SABBATICAL_LEAVE_REQUEST](
    state,
    sabbaticalLeaveRequest
  ) {
    state.sabbaticalLeaveRequest = sabbaticalLeaveRequest;
  },
  [types.SABBATICAL_LEAVE_REQUEST.COMMON_REASONS](
    state,
    sabbaticalLeaveRequests
  ) {
    state.commonReasons = sabbaticalLeaveRequests;
  },

  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL](state, data) {
    state.expireSabbatical = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_DASHBOARD_EXPIRE_SABBATICAL](
    state,
    data
  ) {
    state.expireSabbaticalDashboard = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LOG](state, data) {
    state.expireSabbaticalLog = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LEAVE](state, data) {
    state.expireSabbaticalLeave = data;
  },
  [types.SABBATICAL_LEAVE_REQUEST.CLEAR_DATA](state) {
    state.expireSabbatical = [];
    state.expireSabbaticalLog = [];
  }
};

// actions
export const actions = {
  async listSabbaticalLeaveRequests({ commit }, payload) {
    const response = await axios.get(api.LIST_SABBATICAL_LEAVE_REQUEST, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        approve_person: payload.approvePerson,
        reason_type: payload.reason_type,
        status: payload.status
      }
    });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.FETCH_SABBATICAL_LEAVE_REQUEST,
      response.data.sabbaticalLeaveRequests
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.FETCH_TOTAL_SABBATICAL_LEAVE_REQUEST,
      response.data.totalSabbaticalLeaveRequests
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.COMMON_REASONS,
      response.data.commonReasons
    );
  },

  async detailSabbaticalLeaveRequest({ commit }, sabbaticalLeaveRequestId) {
    const response = await axios.get(
      api.SHOW_SABBATICAL_LEAVE_REQUEST + "/" + sabbaticalLeaveRequestId
    );
    commit(
      types.SABBATICAL_LEAVE_REQUEST.DETAIL_SABBATICAL_LEAVE_REQUEST,
      response.data
    );
  },

  async getDashboardExpireSabbatical({ commit }) {
    let url = `${api.SABBATICAL_DASHBOARD_DAYS_OFF}`;
    const response = await axios.get(url);
    if (response.status == 200) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.GET_DASHBOARD_EXPIRE_SABBATICAL,
        response.data
      );
    }
  },

  async getExpireSabbatical({ commit },sabbaticalRequestId) {
    let url = api.SABBATICAL_DAYS_OFF + "/" + sabbaticalRequestId;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    if (response.status == 200) {
      commit(
        types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL,
        response.data
      );
    }
  },
  async clearData({ commit }) {
    commit(types.SABBATICAL_LEAVE_REQUEST.CLEAR_DATA);
  },
  //sabbatical-log
  async getExpireSabbaticalLog({ commit },sabbaticalRequestId) {
    let url = api.SABBATICAL_LOG + "/" + sabbaticalRequestId;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LOG,
      response.data
    );
  },
  async getExpireSabbaticalLeave({ commit },sabbaticalRequestId) {
    let url = api.SABBATICAL_LEAVE + "/" + sabbaticalRequestId;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    commit(
      types.SABBATICAL_LEAVE_REQUEST.GET_EXPIRE_SABBATICAL_LEAVE,
      response
    );
  }
};
